<template>
  <div class="columns errorbox" v-if="error.length > 0">
    <div class="column is-narrow">
      <span class="icon is-large" aria-hidden=""
        ><i class="zmdi zmdi-alert-triangle is-size-1"></i
      ></span>
    </div>
    <div class="column">
      <p style="white-space: pre;">{{ error }}</p>
      <p>
        <strong
          >You can reload the page to try again or report this problem if it
          reoccurs</strong
        >
      </p>
      <br />
      <button class="button is-info" onClick="window.location.reload(true)">
        <span class="is-size-6">Try Again</span>
      </button>
    </div>
  </div>
</template>

<style scoped>
.errorbox {
  background-color: #262a35;
  border-radius: 8px;
}
</style>

<script>
import { bus } from '../common/bus'

export default {
  name: 'FatalError',
  data() {
    return {
      error: '',
      errorNumber: 1
    }
  },
  mounted() {
    let mountCtx = this
    bus.$on('fatal', function(msg) {
      mountCtx.error += mountCtx.errorNumber + ': ' + msg + '\n'
      mountCtx.errorNumber++
    })
  },
  destroyed() {
    bus.$off('fatal')
  }
}
</script>
